import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserGuideService {
  constructor() {}

  scrollFloatHintShouldAppear(containerComponent: HTMLElement): boolean {
    const wrapper = containerComponent;
    if (!wrapper) {
      return false;
    }
    const pixelsToScrollAvailable = wrapper.scrollHeight - wrapper.clientHeight;
    
    const hintAppearingThreshold = 80; // px
    const hintShouldAppear = pixelsToScrollAvailable >= hintAppearingThreshold;
    return hintShouldAppear;
  }
}
